/** init domain config */
import './config'

import Vue from 'vue'
import App from './App.vue'
import Storage from 'vue-ls'
import router from './router'
import store from './store/'
import { VueAxios } from "@/utils/request"
import '@/permission' // permission control
import '@/utils/filter' // base filter
import Vant from 'vant'
import 'vant/lib/index.css'
// import Vconsole from 'vconsole'
import Video from 'video.js';
import 'video.js/dist/video-js.css';
Vue.prototype.$video = Video;
import wx from 'weixin-js-sdk'
Vue.prototype.wx = wx
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.ignoredElements = ['wx-open-launch-weapp']


// 加载自定义主题
import '@assets/less/whon-theme.less'

import {
  ACCESS_TOKEN
} from "@/store/mutation-types"
import config from '@/defaultSettings'

Vue.config.productionTip = false
Vue.use(Storage, config.storageOptions)
Vue.use(VueAxios, router)
Vue.use(Vant)
Vue.use(ElementUI);
console.log=()=>{}

new Vue({
  router,
  store,
  mounted () {
    store.commit('SET_SIDEBAR_TYPE', true)
    store.commit('TOGGLE_THEME', config.navTheme)
    store.commit('TOGGLE_LAYOUT_MODE', config.layout)
    store.commit('TOGGLE_FIXED_HEADER', config.fixedHeader)
    store.commit('TOGGLE_FIXED_SIDERBAR', config.fixSiderbar)
    store.commit('TOGGLE_CONTENT_WIDTH', config.contentWidth)
    store.commit('TOGGLE_FIXED_HEADER_HIDDEN', config.autoHideHeader)
    store.commit('TOGGLE_WEAK', config.colorWeak)
    store.commit('SET_MULTI_PAGE', config.multipage)
    // 去掉动态切换主色调
    // store.commit('TOGGLE_COLOR', Vue.ls.get(DEFAULT_COLOR, config.primaryColor))
    // store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
  },
  render: h => h(App)
}).$mount('#app')